<template>
  <section class="mt-4">
    <div v-for="(step, idx) in subSteps" :key="idx">
      <b-row align-v="center">
        <b-col cols="3">
          <b-icon
            class="ml-4"
            scale="1"
            :icon="step['status'] !== 'InProgress' ? 'circle-fill' : 'circle'"
            :variant="calcVariant(step)"
          ></b-icon>
        </b-col>
        <b-col class="px-0">
          <p :class="classes(step['status'])">{{ step['title'] }}</p>
        </b-col>
      </b-row>
      <b-row align-v="center">
        <b-col cols="3"> </b-col>
        <b-col class="customColStyle">
          <p class="plannedDates pl-2">{{ calcDateType(step['status'], step['actualDate']) }}</p>
          <p class="plannedDates pl-2">{{ calcDate(step) }}</p>
        </b-col>
      </b-row>
    </div>
  </section>
</template>
<script>
  import moment from 'moment';
  export default {
    props: {
      subSteps: Array,
    },
    data() {
      return {};
    },
    methods: {
      displayLine(step, idx) {
        return step['status'] === 'Completed' && !(idx + 1 === this.subSteps.length);
      },
      classes(status) {
        return status === 'Untouched' ? 'plannedDates text-secondary' : 'plannedDates text-primary';
      },
      formatDate(date) {
        if (date == null || date === '') {
          return '';
        } else {
          return moment(date).format('DD MMM YYYY');
        }
      },
      calcDateType(status, actualDate) {
        let dateValue = actualDate ? moment(actualDate).format('DD MMM YYYY') : 'Not Available';
        return status === 'Completed' && dateValue !== 'Not Available'
          ? 'Actual Date'
          : 'Planned Date';
      },
      calcDate(step) {
        if (step['status'] === 'Completed') {
          if (step['actualDate']) {
            return moment(step['actualDate']).format('DD MMM YYYY');
          } else if (step['plannedDate']) {
            return moment(step['plannedDate']).format('DD MMM YYYY');
          } else {
            return 'Not Available';
          }
        } else {
          return step['plannedDate']
            ? moment(step['plannedDate']).format('DD MMM YYYY')
            : 'Not Available';
        }
      },
      calcVariant(step) {
        let dateValue = step['actualDate']
          ? moment(step['actualDate']).format('DD MMM YYYY')
          : 'Not Available';
        return step['status'] === 'Untouched' ||
          (step['status'] === 'Completed' && dateValue === 'Not Available')
          ? 'secondary'
          : 'primary';
      },
    },
  };
</script>
<style scoped>
  .vl {
    border-left: 2px solid #3c45ea;
    height: 4rem;
    margin-left: 1.8rem;
  }
  .plannedDates {
    font-weight: 400;
    font-size: 11px;
    line-height: 16px;
    letter-spacing: 0.25px;
    color: #6f6f6f;
    margin-bottom: 0px;
  }

  .customColStyle {
    height: 4rem;
    padding-left: 0px;
  }
</style>
